import apiendpoins from "../constants/apiendpoins";
import { apiService } from "./common";

export const getFlats = () => {
  return apiService(apiendpoins.fetchFlats, "GET");
};

export const addFlat = (payload: any) => {
  return apiService(apiendpoins.addFlat, "POST", payload);
};

export const updateFlat = (payload: any) => {
  return apiService(apiendpoins.updateFlat, "PUT", payload);
};

export const deleteFlat = (id: any) => {
  return apiService(`${apiendpoins.deleteFlat}?id=${id}`, "DELETE");
};

export const removeAllotmentFlat = (id: any) => {
  return apiService(`${apiendpoins.removeAllotment}?flat_id=${id}`, "POST");
};

export const randomFlatAssignment = () => {
  return apiService(apiendpoins.flatsRandomAssignment, "POST");
};

export const assignFlatToUser = (paylod: any) => {
  return apiService(apiendpoins.assignFlatToUser, "PUT", paylod);
};

export const searchData = (data: any) => {
  return apiService(`${apiendpoins.searchData}?${data}`, "GET");
};

export const truncateFlats = (phase_id?: any) => {
  return apiService(
    `${apiendpoins.truncateFlats}${phase_id ? `?phase_id=${phase_id}` : ""}`,
    "DELETE"
  );
};

export const truncateFlatUserMapping = (phase_id?: any) => {
  return apiService(
    `${apiendpoins.truncateFlatUserMapping}${
      phase_id ? `?phase_id=${phase_id}` : ""
    }`,
    "DELETE"
  );
};

export const manualFlatAssignment = (paylod: any) => {
  return apiService(`${apiendpoins.manualFlatAssignment}`, "POST", paylod);
};
